import { render, staticRenderFns } from "./ProcesoCompraNormal.vue?vue&type=template&id=4c71f84a"
import script from "./ProcesoCompraNormal.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraNormal.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraNormal.vue?vue&type=style&index=0&id=4c71f84a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports